import * as ActionTypes from '../../../constants/actionTypes';

const initialState = {
  Claims: [],
  EmployeeId: 0,
  Role: '',
  UserId: 0,
  EmailAddress: '',
  LastName: '',
  FirstName: '',
  AuthenticatedEmail: '',
  IsImpersonated: false
};

export default function usersReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SECURITY_USERS_SET:
      return {
        ...state,
        Claims: action.payload.Claims,
        EmployeeId: action.payload.EmployeeId,
        Role: action.payload.Role,
        UserId: action.payload.UserId,
        EmailAddress: action.payload.EmailAddress,
        AuthenticatedEmail: action.payload.AuthenticatedEmail,
        LastName: action.payload.LastName,
        FirstName: action.payload.FirstName
      };
      // Only for impersonation
    case ActionTypes.SECURITY_IMPERSONATE_FETCH:
      return {
        ...state,
        EmailAddress: action.user.SupervisorEmployeeData,
        EmployeeId: Number.parseFloat(action.user.SupervisorEmployeeId),
        IsImpersonated: action.user.IsImpersonated
      };
    case ActionTypes.REDUX_RESET:
      return {
        ...initialState,
      };
    default: return state;
  }
}
